import BasicRouterView from "../../components/BasicRouterView.vue";

const produtosRoutes = {
  path: "prod",
  redirect: { name: "produtos-lista" },
  meta: {
    label: "Produtos",
    icon: "shopping_cart",
    show: true,
  },
  component: BasicRouterView,
  children: [
    {
      path: "produto/lista-produtos",
      name: "produtos-lista",
      meta: {
        label: "Listar",
        icon: "qr_code_scanner",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "produtos" */ "./views/ListarProdutos.vue"),
    },
    {
      path: "produto/imprimir-etiqueta/:produtoId/:contractId",
      name: "imprimir-etiqueta",
      meta: {
        label: "Imprimir",
        icon: "qr_code_scanner",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "produtos" */ "./views/ImprimirEtiqueta.vue"
        ),
    },

    {
      path: "produto/imprimir-etiqueta-old/:produtoId/:contractId",
      name: "imprimir-etiqueta-opcional-old",
      meta: {
        label: "Imprimir",
        icon: "qr_code_scanner",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "produtos" */ "./views/ImprimirEtiquetaNovo.vue"
        ),
    },
    {
      path: "produto/categoria-produtos",
      name: "produtos-categoria",
      meta: {
        label: "Categorias",
        icon: "category",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "produtos" */ "./views/Categorias.vue"),
    },
    {
      path: "produto/gestao-epi-produtos",
      name: "produtos-gestao-epi",
      meta: {
        label: "Gestão EPI's",
        icon: "inventory",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "produtos" */ "./views/GestaoEpis.vue"),
    },
    {
      path: "produto/consulta-produtos",
      name: "produtos-consulta-produtos",
      meta: {
        label: "Consulta de Produtos",
        icon: "inventory",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "produtos" */ "./views/ConsultaProdutos.vue"
        ),
    },
  ],
};

export default produtosRoutes;
